export default "__VITE_ASSET__CS_5tmbW__"